import { FC } from 'react';
import { Typography } from "@mui/material";
import palette from "../../../theme/palette";

interface iErrorText {
    errorMessage: string | undefined;
    className?: string;
}

const ErrorText: FC<iErrorText> = ({ errorMessage, className }) => {
    return errorMessage ? (
        <Typography sx={{color: palette.error.main, m: 0}} className={className ?? ""} variant="subtitle2" style={{marginTop: '4px'}}>
            {errorMessage}
        </Typography>
    ) : (
        <></>
    );
};

export default ErrorText;
